import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { FooterComponent } from '../footer/footer.component';
import { ScrollToTopComponent } from '../../components/scroll-to-top/scroll-to-top.component';
import { SwitcherComponent } from '../../components/switcher/switcher.component';

@Component({
  selector: 'app-default-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NavbarComponent,
    FooterComponent,
    ScrollToTopComponent,
    SwitcherComponent
  ],
  template: `
    <app-navbar></app-navbar>
    <main class="content">
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
    <app-scroll-to-top></app-scroll-to-top>
    <app-switcher></app-switcher>
  `,
  styles: [`
    .content {
      min-height: calc(100vh - 200px); /* Adjust based on your header/footer height */
    }
  `]
})
export class DefaultLayoutComponent {
}
